import { combineReducers, configureStore, UnknownAction } from '@reduxjs/toolkit'
import { createContext } from 'react'
import {
  createDispatchHook,
  createSelectorHook,
  ReactReduxContextValue,
  TypedUseSelectorHook,
} from 'react-redux'

import { worklistPreferencesSlice } from './preferencesSlice'

const combinedReducers = combineReducers({
  worklistPreferences: worklistPreferencesSlice.reducer,
})
type WorklistState = ReturnType<typeof combinedReducers>

// Nullable and null-defaulted because react-redux 9 types its own context that way,
// and `createSelectorHook`/`createDispatchHook` accept nothing else.
export const worklistContext = createContext<ReactReduxContextValue<
  WorklistState,
  UnknownAction
> | null>(null)

export const worklistStore = configureStore({
  reducer: combinedReducers,
  devTools: { name: 'Lucian/Worklists' },
})
type WorklistDispatch = typeof worklistStore.dispatch
const useWorklistSelector = createSelectorHook(worklistContext)
export const useWorklistDispatch: () => WorklistDispatch = createDispatchHook(worklistContext)
export const useTypedWorklistSelector: TypedUseSelectorHook<WorklistState> = useWorklistSelector
